export function getReportCode(){
    const codeRegex = /code=[A-Za-z\d]+/i
    const codeString = codeRegex.exec(window.location.href);
    let code = codeString && codeString[0].replace('code=','');
    if(code==='caso1' || code==='caso2' || code==='caso3'){
        code+='.json';
    }
    return code;
}